module.exports = __webpack_public_path__ + "static/media/site-web.e77fce34.png";